// react
import {
    React,
    useState,
    useEffect,
    Fragment,
} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { getData } from '../../services/fetch-service';

function BlockSlideBox(props) {
    const { locale, location } = props;
    const [allLinks, setAllLinks] = useState([]);
    const [menuname, setMenuName] = useState([]);
    const linkCount = allLinks.length;

    const dynamicStyles = location === 'slider' && linkCount > 0 ? (() => {
        if (linkCount <= 6) {
            return {
                '--logo-size': '70px',
                '--link-font-size': '30px',
                '--link-gap': '30px',
                '--link-padding-left': '50px',
            };
        }

        if (linkCount === 7) {
            return {
                '--logo-size': '65px',
                '--link-font-size': '28px',
                '--link-gap': '28px',
                '--link-padding-left': '48px',
            };
        }

        if (linkCount === 8) {
            return {
                '--logo-size': '60px',
                '--link-font-size': '26px',
                '--link-gap': '26px',
                '--link-padding-left': '46px',
            };
        }

        const baseCount = 8;
        const extra = linkCount - baseCount;
        const t = Math.min(extra / 6, 1);

        const logoSize = Math.round(60 - t * 30);
        const fontSize = Math.round(26 - t * 10);
        const gap = Math.round(26 - t * 12);
        const paddingLeft = Math.round(46 - t * 20);

        return {
            '--logo-size': `${Math.max(logoSize, 30)}px`,
            '--link-font-size': `${Math.max(fontSize, 16)}px`,
            '--link-gap': `${Math.max(gap, 14)}px`,
            '--link-padding-left': `${Math.max(paddingLeft, 26)}px`,
        };
    })() : {};

    if (location === 'home') {
        useEffect(() => {
            getData(`Home/GetMenus?&Gjuha=${locale}&LocationMenuID=7&ParentMenuID=0`).then((response) => {
                setAllLinks(response.data);
                setMenuName(response.data[0].menuLocationName);
            })
        }, []);
    } else if (location === 'slider') {
        useEffect(() => {
            getData(`Home/GetMenus?&Gjuha=${locale}&LocationMenuID=11&ParentMenuID=0`).then((response) => {
                setAllLinks(response.data);
            })
        }, []);
    } else if (location === 'aboutus') {
        useEffect(() => {
            getData(`Home/GetMenus?&Gjuha=${locale}&LocationMenuID=10&ParentMenuID=0`).then((response) => {
                setAllLinks(response.data);
            })
        }, []);
    }
    const linksList = allLinks.map((item, index) => {
        const path = process.env.REACT_APP_FILESPATH;
        const image = `${path}${item.media[0]?.mediaEmri}${item.media[0]?.mediaEx}`;
        return (
            <li key={index}>
                {item.hasChild === true ? (
                    <div className="slider-box-link slider-box-link-childs">
                        <img src={image} alt="" />
                        <div className="link-childs-list">
                            <div className="and-devider">
                                <Link to={item.url}>
                                    {item.pageName}
                                </Link>
                                <p><FormattedMessage id="and" defaultMessage="dhe" /></p>
                            </div>

                            {item.submenu.map((submenu, key) => {
                                return (
                                    <Link key={key} to={submenu.url}>
                                        {submenu.pageName}
                                    </Link>
                                );
                            })}
                        </div>

                    </div>
                )
                    : (
                        <Fragment>
                            {
                                item.otherSource === false ? (
                                    <Link className="slider-box-link" to={item.url}>
                                        <img src={image} alt="" />
                                        {item.pageName}
                                    </Link>
                                ) : (
                                    <a className="slider-box-link" target={item.targeti} href={item.url}>
                                        <img src={image} alt="" />
                                        {item.pageName}
                                    </a>
                                )
                            }
                        </Fragment>
                    )}
            </li>
        );
    });

    return (
        <Fragment>
            <div className="e-service">
                {location !== 'slider' && (
                    <div className="news-ballina">
                        <div className="news-title">
                            <h3>{menuname}</h3>
                        </div>
                    </div>
                )}
                <div className={`block-slideshow__slide-content box-${location}`} style={dynamicStyles}>
                    <ul className="slider-boxes">
                        {linksList}
                    </ul>
                </div>
            </div>
        </Fragment>
    );
}

BlockSlideBox.propTypes = {
    location: PropTypes.oneOf(['home', 'slider', 'aboutus']),
    // locale: PropTypes.string,
};

BlockSlideBox.defaultProps = {
    location: 'home',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockSlideBox);
